/** A URL-safe slug; empty when nothing Latin is left (emoji, other scripts). */
export const normalizeSlug = (slug: string) =>
  slug
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

/** The slug, or "page" (then "page-2", "page-3"…) when it normalizes to nothing. */
export const slugOrFallback = (slug: string, taken: Iterable<string> = []) => {
  const normalized = normalizeSlug(slug);
  if (normalized) return normalized;
  const used = new Set(taken);
  let n = 1;
  while (used.has(n === 1 ? "page" : `page-${n}`)) n += 1;
  return n === 1 ? "page" : `page-${n}`;
};

/**
 * Title and slug for a copy of a page: "About copy" / "about-copy", then
 * "About copy 2" / "about-copy-2" and so on, skipping any already in use.
 */
export const copyNames = (
  page: { title: string; slug: string },
  takenTitles: Iterable<string>,
  takenSlugs: Iterable<string>,
) => {
  const titles = new Set(takenTitles);
  const slugs = new Set(takenSlugs);
  for (let n = 1; ; n += 1) {
    const title = n === 1 ? `${page.title} copy` : `${page.title} copy ${n}`;
    const slug = n === 1 ? `${page.slug}-copy` : `${page.slug}-copy-${n}`;
    if (!titles.has(title) && !slugs.has(slug)) return { title, slug };
  }
};
